import { createRequestActionNames } from 'helpers'

export const STORIES = createRequestActionNames('STORIES', ['GET'])
export const STORIES_LOAD_MORE = createRequestActionNames('STORIES_LOAD_MORE', ['GET'])
export const STORIES_GET_PROTRACKS = createRequestActionNames('STORIES_GET_PROTRACKS', ['GET'])
export const STORIES_SCROLL = 'STORIES_SCROLL'
export const STORIES_ENABLE_PENDING = 'STORIES_ENABLE_PENDING'
export const STORIES_ENABLE_LOAD_MORE_PENDING = 'STORIES_ENABLE_LOAD_MORE_PENDING'
export const SET_SELECTED_PROTRACK = 'SET_SELECTED_PROTRACK'
